(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mahe-hero-fan"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mhf-fan][data-autoplay]').forEach(function (fan) {
    var cards = Array.prototype.slice.call(fan.querySelectorAll('.mhf__card'));
    if (cards.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var POS = ['mhf__card--p1', 'mhf__card--p2', 'mhf__card--p3'];
    var ALL = POS.concat(['mhf__card--in', 'mhf__card--out', 'mhf__card--off']);
    var interval = (parseInt(fan.dataset.interval, 10) || 4) * 1000;
    var queue = cards.slice(); // queue[0..2] mirror positions p1..p3
    var busy = false;
    var paused = false;

    function setClass(card, cls) {
      ALL.forEach(function (c) {
        card.classList.remove(c);
      });
      card.classList.add(cls);
    }

    function advance() {
      if (busy || paused || document.hidden) return;
      busy = true;

      var leaving = queue[Math.min(2, queue.length - 1)];
      var incoming = queue.length > 3 ? queue[3] : leaving;

      // rightmost slides out right and fades; the rest shift one spot right
      setClass(leaving, 'mhf__card--out');
      setClass(queue[0], 'mhf__card--p2');
      if (queue[1] !== leaving) setClass(queue[1], 'mhf__card--p3');

      window.setTimeout(function () {
        // reorder the queue so queue[0..2] keep mirroring positions p1..p3
        if (incoming !== leaving) {
          queue.splice(queue.indexOf(incoming), 1);
          queue.splice(queue.indexOf(leaving), 1);
          queue.unshift(incoming);
          queue.push(leaving);
        } else {
          queue.splice(queue.indexOf(leaving), 1);
          queue.unshift(leaving);
        }
        // Stage the incoming card at the left with transitions disabled,
        // wait two frames so the browser commits that style, then move it to
        // p1 so the slide/fade-in transition actually runs.
        setClass(incoming, 'mhf__card--in');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            setClass(incoming, 'mhf__card--p1');
            busy = false;
          });
        });
      }, 700);
    }

    var timer = window.setInterval(advance, interval);
    fan.addEventListener('mouseenter', function () {
      paused = true;
    });
    fan.addEventListener('mouseleave', function () {
      paused = false;
    });
    window.addEventListener('pagehide', function () {
      window.clearInterval(timer);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
